import {
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild,
  Inject,
  Injectable,
} from '@angular/core';

import { DOCUMENT } from '@angular/platform-browser';
import { Router } from '@angular/router';

import { DragDropDirectiveModule } from 'angular4-drag-drop';

import { forEach } from '@angular/router/src/utils/collection';
import { AuthService } from '../service/auth.service';
import { CompanyService } from '../service/company.service';
import { LoanService } from '../service/loan.service';
import { PrintService } from '../service/print.service';
import { ProjectService } from '../service/project.service';

@Component({
  selector: 'app-printing',
  templateUrl: './printing.component.html',
  styleUrls: ['./printing.component.css'],
})
export class PrintingComponent {
  constructor(
    private companyService: CompanyService,
    private loanService: LoanService,
    private auth: AuthService,
    private router: Router,
    private projectService: ProjectService,
    private printService: PrintService,
    @Inject(DOCUMENT) private document: any
  ) {
    this.projectId = localStorage.getItem('projectId');
    this.companyId = localStorage.getItem('companyId');
    this.getProjectData();
    this.getCompanyData();
    this.getPackage();
    this.childShow = false;
    localStorage.removeItem('investors_id');
    this.investorsIdArray = [];
    this.investorsNameArray = [];
  }

  // DECLARATION OF INPUT,OUTPUT VARIABLES TO COMMUNICATE B/W PARENT AND CHILD
  @ViewChild('closeBtn') closeBtn: ElementRef;

  @ViewChild('myModal') myModal: ElementRef;

  // DECLARATION OF ALL VARIABLES

  // left array of drag & drop
  itemStringsLeft: any[] = [
    'Cover Page',
    'Project Data',
    'Budget / Costs',
    'Financing',
    'Operating Expenses',
    'Cash Flow',
    'RAL Enterprise Appraisal™',
    'RAL Investor Architect™',
    'Financial Reports',
    'Recast',
    'Loan Schedules',
    'Summary',
  ];

  // left array of drag & drop
  itemStringsRight: any[] = [];

  companyLogoUrl = '';

  companyId = '';

  projectId = '';

  projectName = '';

  packageName = '';

  childShow: boolean;

  customPackages: any[] = [];

  investors: string[] = new Array();

  investorsIdArray: string[] = new Array();

  investorsNameArray: string[] = new Array();

  // GET PROJECT NAME FROM PROJECT TABLE(DB)
  getProjectData() {
    this.projectService.getProject(this.projectId).subscribe((projectData) => {
      this.projectName = projectData.data[0].project_name;
    });
  }

  // GET COMPANY LOGO FROM COMPANY TABLE(DB)
  getCompanyData() {
    this.companyService.getCompany(this.companyId).subscribe((res) => {
      this.companyLogoUrl = res.data[0].logoUrl;
    });
  }

  // GET SAVED LOANS FROM DB
  getLoansData(): Promise<Boolean> {
    const self = this;
    return new Promise((resolve, reject) => {
      this.loanService.getUniqueLoans(this.projectId).subscribe((loanData) => {
        this.investors = loanData.data;
        resolve(true);
      });
    });
  }

  // GET SAVED CUSTOM PACKAGES
  getPackage() {
    this.printService.getPackage().subscribe((res) => {
      this.customPackages = res.data;
    });
  }

  // SET ITEMS INTO ARRAY WHEN ANG PAGE IS DROPPED IN RIGHT SIDE OF DRAG & DROP
  releaseDrop(event) {
    for (let i = 0; i < event.length; i++) {
      this.itemStringsRight[i] = event[i];
    }
  }

  // SELECT PRINTABLE PAGES ACCORDING TO SELECTED PACKAGE
  selectPrintPages(packageObj) {
    const explodeditemLeft = [
      'Cover Page',
      'Project Data',
      'Budget / Costs',
      'Financing',
      'Operating Expenses',
      'Cash Flow',
      'RAL Enterprise Appraisal™',
      'RAL Investor Architect™',
      'Financial Reports',
      'Recast',
      'Loan Schedules',
      'Summary',
    ];

    this.itemStringsRight = [];
    this.itemStringsLeft = [];
    let explodedPages1;

    // CONDITION WHEATHER TO SHOW SUB-MENU FOR CHECKBOXS OR NOT. SUB-MENU WILL SHOW ONLY IN CASE OF "Investor Full"
    if (packageObj.package_name === 'Investor Full') {
      this.getLoansData();
      this.childShow = true;
    } else {
      this.childShow = false;
      this.investorsIdArray = [];
      this.investorsNameArray = [];
    }

    // LOOPS IS TO EXTRACT PAGES FROM CUSTOM PACAKAGE WHEN ANY CUSTOM PACKAGE IS SELECTED
    for (let i = 0; i < this.customPackages.length; i++) {
      if (this.customPackages[i].package_name === packageObj.package_name) {
        const allPages: any = this.customPackages[i].page_name;
        const explodedPages = allPages.join(',');
        explodedPages1 = explodedPages.split(',');
        for (let i = 0; i < explodedPages1.length; i++) {
          this.itemStringsRight.push(explodedPages1[i]);
        }
      }
    }

    for (let i = 0; i < explodedPages1.length; i++) {
      const element = explodedPages1[i];
      if (explodeditemLeft.indexOf(element) >= 0) {
        explodeditemLeft.splice(explodeditemLeft.indexOf(element), 1);
      }
    }
    for (let i = 0; i < explodeditemLeft.length; i++) {
      this.itemStringsLeft.push(explodeditemLeft[i]);
    }
  }

  // SAVE NEW PRINT CUSTOM PACKAGE
  savePackage(pageArray: string[]) {
    const data = { package_name: this.packageName, page_names: this.itemStringsRight };
    this.printService.updatePackage(data).subscribe((res) => {
      this.getPackage();
      this.closeModal();
    });
  }

  // CLEAR PRINTABLE PAGES
  clear() {
    const radio_buttons = document.getElementsByName('radio_buttons') as NodeListOf<HTMLInputElement>;
    for (let i = 0; i < radio_buttons.length; i++) {
      radio_buttons[i].checked = false;
    }
    this.childShow = false;
    this.investorsIdArray = [];
    this.investorsNameArray = [];
    this.itemStringsLeft = [];
    this.itemStringsLeft.push(
      'Cover Page',
      'Project Data',
      'Budget / Costs',
      'Financing',
      'Operating Expenses',
      'Cash Flow',
      'RAL Enterprise Appraisal™',
      'RAL Investor Architect™',
      'Financial Reports',
      'Recast',
      'Loan Schedules',
      'Summary'
    );
    this.itemStringsRight = [];
  }

  // TO OPEN MODAL AFTER VALIDATING THAT THERE ARE PAGES TO CREATE PACKAGE OR NOT
  openModal() {
    if (this.itemStringsRight.length <= 0) {
      alert('Select pages to create package');
    } else {
      document.getElementById('openModalButton').click();
    }
  }

  // TO CLOSE MODEL
  private closeModal(): void {
    this.closeBtn.nativeElement.click();
  }

  // REMOVE PRINT CUSTOM PACKAGE
  removePackage(package_object) {
    if (confirm(`Are you sure you want to delete ${package_object.package_name} ?`)) {
      this.printService.removePackage(package_object._id).subscribe((res) => {
        this.getPackage();
        this.clear();
      });
    }
  }

  // SET PAGES FOR PRINTING AND SHOW PRINT PREVIEW
  print() {
    if (this.itemStringsRight.length <= 0) {
      alert('Select pages for printing');
    } else {
      localStorage.removeItem('names');
      localStorage.setItem('names', JSON.stringify(this.itemStringsRight));
      this.investorsIdArray = [];
      this.loanService.getLoanIds(this.projectId, this.investorsNameArray).subscribe((res) => {
        this.investorsIdArray = res.data;
        localStorage.setItem('investors_id', JSON.stringify(this.investorsIdArray));
      });
      window.open('/print');
      //      window.location.href = '/print';
    }
  }

  // SET INVESTORS FOR PRINTING IN RAL INVESTOR ARCHITECT PAGE AND SHOW PRINT PREVIEW
  setInvestors(investor: any, event) {
    if (investor === 'all') {
      if (event.target.checked === false) {
        this.investorsNameArray = [];
        const check_boxs = document.getElementsByName('check_boxs') as NodeListOf<HTMLInputElement>;
        for (let i = 0; i < check_boxs.length; i++) {
          check_boxs[i].checked = false;
        }
      } else {
        this.investorsNameArray = [];
        const check_boxs = document.getElementsByName('check_boxs') as NodeListOf<HTMLInputElement>;
        for (let i = 0; i < check_boxs.length; i++) {
          check_boxs[i].checked = true;
        }
        for (let i = 0; i < this.investors.length; i++) {
          this.investorsNameArray.push(this.investors[i]);
        }
      }
    } else if (this.investorsNameArray.indexOf(investor) === -1) {
      this.investorsNameArray.push(investor);
    } else {
      this.investorsNameArray.splice(this.investorsNameArray.indexOf(investor), 1);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/printing/printing.component.ts